import React from 'react';

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://facebook.com',
    color: '#1877F2',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    url: 'https://instagram.com',
    color: '#E1306C',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.326 3.608 1.301.975.975 1.24 2.242 1.301 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.326 2.633-1.301 3.608-.975.975-2.242 1.24-3.608 1.301-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.326-3.608-1.301C2.489 19.483 2.224 18.216 2.163 16.85 2.105 15.584 2.093 15.204 2.093 12s.012-3.584.07-4.85c.062-1.366.326-2.633 1.301-3.608C4.439 2.489 5.706 2.224 7.072 2.163 8.337 2.105 8.717 2.093 11.921 2.093h.079zm0-2.163c-3.259 0-3.667.014-4.947.072C5.598.195 4.198.538 3.012 1.724 1.826 2.91 1.483 4.31 1.425 5.755.367 7.035.353 7.443.353 12s.014 4.965.072 6.245c.058 1.445.401 2.845 1.587 4.031 1.186 1.186 2.586 1.529 4.031 1.587C7.323 23.921 7.731 23.935 12 23.935s4.677-.014 5.957-.072c1.445-.058 2.845-.401 4.031-1.587 1.186-1.186 1.529-2.586 1.587-4.031.058-1.28.072-1.688.072-6.245s-.014-4.965-.072-6.245C23.517 4.31 23.174 2.91 21.988 1.724 20.802.538 19.402.195 17.957.137 16.677.079 16.269.065 12 .065v-.065zM12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
      </svg>
    ),
  },
  {
    name: 'Twitter / X',
    url: 'https://twitter.com',
    color: '#ffffff',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    name: 'YouTube',
    url: 'https://youtube.com',
    color: '#FF0000',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>⛵ RegattaCentral</h4>
          <p>The premier summer sailing event on the coast. Join the wind, feel the waves.</p>
        </div>

        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>📧 info@jeklabs.com</p>
          <p>📞 +1 (555) SAIL-NOW</p>
          <p>📍 123 Marina Way, Harbor City</p>
        </div>

        <div className="footer-section">
          <h4>Follow the Race</h4>
          <div className="social-links">
            {socialLinks.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noreferrer"
                className="social-link-item"
                aria-label={s.name}
              >
                <span className="social-icon" style={{ color: s.color }}>{s.icon}</span>
                <span className="social-label">{s.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} RegattaCentral Business. All Rights Reserved.</p>
        <p className="footer-powered">
          Powered by{' '}
          <a href="https://jeklabs.com" target="_blank" rel="noreferrer">
            JEK Labs
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
